import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import { HarmonizationResultCard } from '../harmonization-result-card';
import { bulkHarmonizationMessages } from './messages';
import styles from './styles.module.less';

/**
 * @param {{
 *   suggestions: Array<import('./harmonization-api').HarmonizationSuggestion>,
 *   acceptedCode: string | null,
 *   onSelectCode: (code: string) => void
 * }} props
 * @returns {React.ReactElement}
 */
export const BulkHarmonizationSidePanel = ({ suggestions, acceptedCode, onSelectCode }) => {
  const hasSuggestions = suggestions && suggestions.length > 0;

  return (
    <div className={styles.sidePanel}>
      <div className={styles.sidePanelContent}>
        {hasSuggestions ? (
          suggestions.map((suggestion) => (
            <HarmonizationResultCard
              key={suggestion.suggestedCode}
              code={suggestion.suggestedCode}
              confidence={suggestion.confidenceLevel}
              isSelected={acceptedCode === suggestion.suggestedCode}
              onClick={() => onSelectCode(suggestion.suggestedCode)}
              reasoning={suggestion.reasoning}
              referenceChapter={suggestion.referenceChapter}
            />
          ))
        ) : (
          <Text textType={TextType.Paragraph} value={bulkHarmonizationMessages.noSuggestionsAvailable} />
        )}
      </div>
    </div>
  );
};
